module.exports = __webpack_public_path__ + "img/LogoBms2.285fb84d.jpg";